module.exports = __webpack_public_path__ + "static/media/slim-branco.7a8c4ecd.jpg";